import React from 'react';
import {
  LayoutDashboard,
  GitBranch,
  Shield,
  Database,
  Boxes,
  Plug,
} from 'lucide-react';
import { CRM_MAP_VIEWS, CrmMapViewId } from '../../utils/crmArchitectureMapData';
import '../ops/OpsSidebar.css';

const VIEW_ICONS: Record<CrmMapViewId, React.ReactNode> = {
  overview: <LayoutDashboard size={15} />,
  lifecycle: <GitBranch size={15} />,
  roles: <Shield size={15} />,
  data: <Database size={15} />,
  domains: <Boxes size={15} />,
  integrations: <Plug size={15} />,
};

interface CrmMapSidebarProps {
  activeView: CrmMapViewId;
  onSelectView: (view: CrmMapViewId) => void;
}

const CrmMapSidebar: React.FC<CrmMapSidebarProps> = ({ activeView, onSelectView }) => {
  return (
    <div className="ops-sidebar">
      <div className="ops-sidebar-header">
        <span className="ops-sidebar-label">Architecture</span>
      </div>

      <nav className="ops-sidebar-nav">
        {CRM_MAP_VIEWS.map((view) => {
          const isActive = view.id === activeView;
          return (
            <button
              key={view.id}
              type="button"
              className={`ops-sidebar-item ${isActive ? 'active' : ''}`}
              onClick={() => onSelectView(view.id)}
            >
              <span className="ops-sidebar-item-icon">{VIEW_ICONS[view.id]}</span>
              <span className="ops-sidebar-item-label">{view.label}</span>
            </button>
          );
        })}
      </nav>

      <div className="crm-map-sidebar-foot">
        <span>Reference only · no live data</span>
      </div>
    </div>
  );
};

export default CrmMapSidebar;
